import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import Modal from "../common/Modal/Modal";
import {addProject, getCompanyPojects, clearProject, setProjectDrop} from "../../actions/projects";
import {respondToContractInvitation, respondToApprovalInvitation} from "../../actions/contract";

export function AppendProjectModal(props) {

const contract = useSelector(state => state.contract.contract);
const contracts = useSelector(state => state.contract.contracts);
const project = useSelector(state => state.projects.project);
const projectDrop = useSelector(state => state.projects.projectDrop);
const company_projects = useSelector(state => state.projects.company_projects);

const [existingProject, setExistingProject] = useState(null);
const [createNew, setCreateNew] = useState(false);
const newProjectInitial = {
    project_name: null,
    country: null,
    street: null,
    city: null,
}
const [newProject, setNewProject] = useState(newProjectInitial);
const [submitting, setSubmitting] = useState(false);

// on mount, get list of company projects for dropdown selection
useEffect(() => {
    project.project_id && props.clearProject();
    props.getCompanyPojects();
}, [])

// when Invitation Response is complete, if successful, close modal
useEffect(() => {
    if (contract.project_id) {
        props.setProjectModalOpen(false);
    }
}, [contract.project_id]);

const handleStartNew = (e) => {
    e.preventDefault(e)
    setCreateNew(true);
    existingProject && setExistingProject(null);
}

// SUBMIT PROJECT FORM
const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    // If submitting existing project, respond to invite with pid
    if (existingProject) {
        const role =  contract.invitations[0].role;  
        const role_id =  contract.invitations[0].role_id;  
        const body = {status: "Active", pid: existingProject};
        const existing = contracts.filter(item => item.contract_id === contract.contract_id).length > 0;
        role.startsWith("APP") 
        ? props.respondToApprovalInvitation(role_id, body, contract.contract_id, existing)
        : props.respondToContractInvitation(role_id, body, contract.contract_id, existing);
    // Otherwise, create new project and wait for data response, then respond to invite with new pid
    } else {
        props.addProject(newProject);
    }
} // When Project Form submission is successful (data returns), answer invitation using new project
useEffect(() => {
    if (project.project_id && submitting) {
        const role =  contract.invitations[0].role;  
        const role_id =  contract.invitations[0].role_id;  
        const body = {status: "Active", pid: project.project_id};
        const existing = contracts.filter(item => item.contract_id === contract.contract_id).length > 0;
        role.startsWith("APP") 
        ? props.respondToApprovalInvitation(role_id, body, contract.contract_id, existing)
        : props.respondToContractInvitation(role_id, body, contract.contract_id, existing);
    }
}, [project.project_id, submitting]);

const handleChangeNewProject = (e) => {
    existingProject && setExistingProject(null);
    setNewProject({...newProject, [e.target.name]: e.target.value})
}

const handleSelectExisting = (e) => {
    e.preventDefault();
    createNew && setCreateNew(false);
    (newProject.project_name || newProject.country || newProject.street || newProject.city) && setNewProject(newProjectInitial);
    setExistingProject(e.target.value);
}

    return (
        <Modal blurBack={true} hasCloseButton={true} hideLogo handleClose={() => props.setProjectModalOpen(false)} >
                <div className="flex-column w100" >
                    <form onSubmit={(e) => handleSubmit(e)} className="form" >
                    <h3 className="title2 gap-below-s heavy t-center">Save Contract to a Project </h3>
                        <h4 className="content1 light-black gap-below-xxs">Select an existing company project</h4>
                        <div className="inputs-wrapper gap-below-s">
                            <div className="input-basic">										
                                <select 
                                    name="project_id" 
                                    id="project_id" 
                                    style={existingProject ? {color: "#3C3B41" } : {color: "#919197"}}
                                    onChange={(e) => handleSelectExisting(e)}
                                    value={existingProject ? existingProject : ""}
                                    required={!createNew}
                                >
                                    <option value={""} >Select a project</option>
                                    {company_projects && company_projects.map((project) => {
                                        return <option key={project.project_id} value={project.project_id} >{project.project_name}</option>
                                    })}
                                </select>
                                <label htmlFor="name">Existing Project {!createNew &&<span>*</span>}</label>
                            </div>
                        </div>
                        <div className="gap-below-m">
                            <h4 className="content1 light-black gap-below-xxs">Or create a&nbsp;
                                <button id="contract_create_project" 
                                    className="link1" 
                                    onClick={(e) => handleStartNew(e)}> new project +</button>
                            </h4>
                            {createNew &&
                            <div className="inputs-wrapper gap-below-m"> 
                                <div className="input-basic">										
                                    <input
                                        type="text"
                                        name="project_name"
                                        id="project_name"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="project_name">Project Name {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="country"
                                        id="country"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="country">Country {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="street"
                                        id="street"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="street">Street Address {createNew && <span>*</span>}</label>
                                </div>
                                <div className="input-basic">
                                    <input
                                        type="text"
                                        name="city"
                                        id="city"
                                        onChange={(e) => handleChangeNewProject(e)}
                                        required={createNew}
                                    />
                                    <label htmlFor="city">City {createNew && <span>*</span>}</label>
                                </div>
                            </div>}
                        </div>
                        <div className="flex-row">
                            <button id="save_to_project" className="btn pri expand gap-right-xs" type="submit" disabled={(!newProject.project_name && !existingProject) || submitting}>{submitting ? "Please wait..." : "Save to Project"}</button>
                            <button 
                                className="btn sec expand" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.setProjectModalOpen(false)
                                }}>Cancel
                            </button>
                        </div>
                    </form>
                </div>    
        </Modal>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {addProject, respondToApprovalInvitation, getCompanyPojects, clearProject, respondToContractInvitation, setProjectDrop})(AppendProjectModal);